import { FEEDERLISTS, LABOR, LABORCREW } from "../_constants/actionConstants";

/**
 * Notes on implementation:
 * - laborCrews reducer does NOT have openLaborCrewDetails, unlike others.
 *   This is because the projLaborCrew list itself already contains all necessary
 *   data.
 */
const initialState = {
  projLaborCrewLists: {}, // Normalized by projectId
  miscSessionData: {}, // Normalized by tabId
  fetching: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LABORCREW.ADD:
    case LABORCREW.DELETE:
    case LABORCREW.EDIT:
    case LABORCREW.FETCH_ALL:
    case LABORCREW.GENERIC_REQUEST:
    case LABORCREW.EDIT_FULFILLED:
    case LABORCREW.DELETE_FULFILLED:
    case LABORCREW.ADD_FULFILLED:
      return { ...state, fetching: true };

    case LABORCREW.GENERIC_REQUEST_FULFILLED:
    case LABORCREW.GENERIC_REQUEST_REJECTED:
    case LABORCREW.DELETE_REJECTED:
      return { ...state, fetching: false };

    case LABORCREW.FETCH_ALL_FULFILLED:
    case FEEDERLISTS.FETCH_FULFILLED: {
      const { projectId, projLaborCrewList } = action;
      if (!projectId || !projLaborCrewList) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projLaborCrewLists: {
          ...state.projLaborCrewLists,
          [projectId]: projLaborCrewList,
        },
      };
    }

    default:
      return state;
  }
};
